var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99984 2.41667H10.9998V0.916672H2.99984V2.41667ZM2.4165 11V5H0.916504V11H2.4165ZM2.4165 5V3H0.916504V5H2.4165ZM11.5832 3.00001V5H13.0832V3.00001H11.5832ZM11.5832 5V11H13.0832V5H11.5832ZM1.6665 5.75H12.3332V4.25H1.6665V5.75ZM0.916504 11C0.916504 12.1506 1.84924 13.0833 2.99984 13.0833V11.5833C2.67767 11.5833 2.4165 11.3222 2.4165 11H0.916504ZM10.9998 13.0833C12.1504 13.0833 13.0832 12.1506 13.0832 11H11.5832C11.5832 11.3222 11.322 11.5833 10.9998 11.5833V13.0833ZM10.9998 2.41667C11.322 2.41667 11.5832 2.67784 11.5832 3.00001H13.0832C13.0832 1.84941 12.1504 0.916672 10.9998 0.916672V2.41667ZM2.99984 0.916672C1.84924 0.916672 0.916504 1.84941 0.916504 3H2.4165C2.4165 2.67784 2.67767 2.41667 2.99984 2.41667V0.916672ZM10.9998 11.5833H2.99984V13.0833H10.9998V11.5833Z",
    fill: "blue"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.48673f924792976d3c6bcae595d7154e.svg";
export { ForwardRef as ReactComponent };